<script lang="ts">
import { defineComponent, PropType } from "vue";
import TimeSlotsPicker from "@/shared/components/TimeSlotsPicker.vue";
import getSpeedCount from "@/shared/utils/misc/get-speed-count";
import { injectOut } from "@/shared/utils/injection";
import { outsByName } from "@/shared/utils/outs";
import { getConstantValue, getConstantLabel } from "@/shared/utils/constants";

export default defineComponent({
  ...injectOut,
  components: { TimeSlotsPicker },
  props: {
    planNames: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  data: function () {
    return {
      selectedPlanName: this.planNames[0],
    };
  },
  watch: {
    planNames() {
      this.selectedPlanName = this.planNames[0];
    },
  },
  computed: {
    plan() {
      return this.pool.plans.find(
        (plan) => plan.index === getConstantValue(this.selectedPlanName!)
      );
    },
    speedCount() {
      if (
        this.out?.index === outsByName["OUT_FILTRE"].index &&
        this.selectedPlanName === "PLAN_VF"
      ) {
        return getSpeedCount(this.pool);
      }
      return 1;
    },
  },
  methods: {
    getConstantLabel,
    updatePlan(slots: number[]) {
      const planIdx = this.pool.plans.findIndex(
        (plan) => plan.index === this.plan?.index
      );
      this.pool.plans[planIdx].slots = slots;
    },
  },
});
</script>

<template>
  <div v-if="planNames.length > 1" class="flex mt-2">
    <div
      v-for="planName in planNames"
      :key="planName"
      class="pill"
      :class="planName === selectedPlanName ? 'active' : ''"
      @click="selectedPlanName = planName"
    >
      {{ $t(getConstantLabel(planName)!) }}
    </div>
  </div>
  <time-slots-picker
    :key="plan?.index"
    :slots="plan!.slots"
    :num-values="speedCount"
    :force-labels="plan?.forceLabels"
    @change="updatePlan"
    :read-only="selectedPlanName === 'PLAN_FILTREAUTO'"
    :exclude="
      selectedPlanName === 'PLAN_DIS_FILTRE' ||
      selectedPlanName === 'PLAN_DIS_CHAUFF'
    "
  />
</template>
